import { Box } from '@mui/material';

import FeedbackStarSvg from '~/assets/icons/new/feedback-star.svg?react';

import useFeedbackStarIconStyles, {
  type FeedbackStarDisplayMode,
} from './FeedbackStarIcon.styles';

const DEFAULT_SIZE_PX = 32;

type FeedbackStarIconProps = {
  /**
   * `empty` = outline; `gold` = 1–3; `green` = 4+ (matches prior design).
   */
  displayMode: FeedbackStarDisplayMode;
  /** Display size in CSS pixels; default 32 (modal). Use a smaller value in tables. */
  size?: number;
};

/**
 * Renders the shared `feedback-star.svg` asset. Outline uses `empty` styles;
 * fills use `filled` with `COLOR_PALETTE.common.gold` and
 * `theme.new.color.success[600]` (design system) like other UI.
 */
export function FeedbackStarIcon({
  displayMode,
  size = DEFAULT_SIZE_PX,
}: FeedbackStarIconProps) {
  const { classes, cx } = useFeedbackStarIconStyles({ displayMode });
  const isEmpty = displayMode === 'empty';

  return (
    <Box
      component="span"
      className={cx(
        classes.root,
        isEmpty && classes.empty,
        !isEmpty && classes.filled
      )}
      style={{ width: size, height: size }}
    >
      <FeedbackStarSvg width={size} height={size} />
    </Box>
  );
}
